/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';
import { enableProdMode, LOCALE_ID } from '@angular/core';
import { environment } from '@environments/environment';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

const userLang = navigator.language;
let localeId = 'en-US';
if (userLang.startsWith('de')) {
  localeId = 'de-DE';
}

appConfig.providers.push({ provide: LOCALE_ID, useValue: localeId });

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
